// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"2749ad67","712":"2a23f8ba","787":"3bcd0593","858":"e84c7852"}[chunkId] + ".chunk.js";
};